// Score de complétude d'une fiche contact — brique UNIQUE (source de vérité).
// Avant : la logique était dupliquée dans ContactDetail (jauge + détail),
// avec le risque qu'une évolue sans l'autre. Total = 100 pts.

export const QUALITY_FIELDS = [
  { key: 'first_name',          label: 'Prénom',       pts: 15, done: c => !!c.first_name },
  { key: 'last_name',           label: 'Nom',          pts: 15, done: c => !!c.last_name },
  { key: 'email',               label: 'E-mail',       pts: 25, done: c => !!c.email },
  { key: 'phone',               label: 'Téléphone',    pts: 15, done: c => !!c.phone },
  { key: 'birth_date',          label: 'Anniversaire', pts: 10, done: c => !!c.birth_date },
  { key: 'gender',              label: 'Civilité',     pts: 5,  done: c => !!c.gender && c.gender !== 'non_renseigne' },
  { key: 'city',                label: 'Ville',        pts: 10, done: c => !!c.city },
  { key: 'relationship_memory', label: 'Mémoire',      pts: 5,  done: c => !!c.relationship_memory },
];

/** Détail champ par champ : [{key, label, pts, done}]. */
export function qualityBreakdown(c = {}) {
  return QUALITY_FIELDS.map(f => ({ key: f.key, label: f.label, pts: f.pts, done: f.done(c) }));
}

/** Score total 0→100. */
export function qualityScore(c = {}) {
  return QUALITY_FIELDS.reduce((s, f) => s + (f.done(c) ? f.pts : 0), 0);
}
